import { Component, NgZone, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ChartService } from "../../services/chart.service";
import { CommonService } from "src/app/services/common.service";

@Component({
  standalone: false,
    selector: "app-workforce",
    templateUrl: "./workforce.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./workforce.component.scss"],
})
export class WorkforceComponent implements OnInit {
    workforceInfoOpen: boolean;
    zIndex = 0;
    activateEndpoint: string;
    employee_stats: any;
    average_exposure: any;
    colors = this.commonService.colors;

    constructor(
        private chartService: ChartService,
        private commonService: CommonService,
        private zone: NgZone,
    ) {}

    ngOnInit(): void {
        this.zone.runOutsideAngular(() => {
            setTimeout(async () => {
                await this.chartService.setGaugeChart("gaugeChart3", 0);
                await this.chartService.setGaugeChart("gaugeChart4", 0);
            }, 3000);
        });
    }

    hideView() {
        this.workforceInfoOpen = false;
    }

    flyOut(flyOutTab: string, zIndex?: number) {
        this.activateEndpoint = flyOutTab;
        if (zIndex) {
            this.zIndex = zIndex;
        } else {
            this.zIndex = 0;
        }
        try {
            switch (this.activateEndpoint) {
                case "ActiveCompliance":
                    if (window.outerWidth < 1000) {
                        document.documentElement.scrollTop = 0;
                    }
                    break;
                case "ActiveEndPoint":
                    if (window.outerWidth < 1000) {
                        document.documentElement.scrollTop = 0;
                    }
                    break;
                case "ActiveAlarmNotification":
                    if (window.outerWidth < 1000) {
                        document.documentElement.scrollTop = 900;
                    }
                    break;
            }
        } catch (e) {}
    }
}
